export default "__VITE_ASSET__ZQQ6yKGi__"